<template>
    <div class="split-lines-elem">
        <slot></slot>
    </div>
</template>

<script>
import SplitLines from '@/utils/SplitLines'

export default {
  name: 'app-split-lines-elem',

  props: {

  },

  computed: {

  },

  data() {
      return {
        intersectionObserver: null
      }
  },

  created()
  {
      this.elem = null
  },

  mounted()
  {

  },

  destroyed()
  {
      this.intersectionObserver.disconnect()
  },

  methods: {
    initSplitLines(elem)
    {
        this.elem = elem

        this.splitText = new SplitLines(this.elem)
        this.initObserver()
    },

    initObserver()
    {
        const options = {
            threshold: 0.05
        }

        this.intersectionObserver = new IntersectionObserver(entries => {
            const par = entries[0]

            if (par.isIntersecting)
            {
                // console.log('paragraph intersected')
                this.$el.classList.add('has-appeared')

                this.intersectionObserver.disconnect()
            }
        }, options)

        this.intersectionObserver.observe(this.$el)
    }
  }
}
</script>

<style lang="stylus">
.splitted-line
    display block
    overflow hidden

.splitted-line__inner
    display block
    transform translate3d(0, 70%, 0)
    transition transform 1.2s $ease-out-quart
    transform-origin bottom left

    .has-appeared &
        transform translate3d(0, 0, 0)

.splitted-line
    &:nth-child(2)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.1s
    &:nth-child(3)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.15s
    &:nth-child(4)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.2s
    &:nth-child(5)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.25s
    &:nth-child(6)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.3s
    &:nth-child(7)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.35s
    &:nth-child(8)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.4s
    &:nth-child(9)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.45s
    &:nth-child(10)
        .splitted-line__inner
            transition transform 1s $ease-out-quart 0.5s
</style>